<template>
    <div v-if="showNoDataImgForUser">
        <div class="progressImgDataContainer">
            <div class="progressDataText">
                <h4>Your data has been successfully added to Weavr!</h4>
                <p>Please check back in 24 hours.</p>
            </div>
            <div class="progressImgWrapper">
                <img src="Icons_SVG/progressDataImgUpdated.svg" alt="data in progress" />
            </div>
        </div>
    </div>
    <div v-else id="product-reviews">
        <div v-show="loader || reviewLoader || countLoader || vocLoader || topProductsLoaderForTabs || loaderUpdated">
            <Loader />
        </div>
        <div class="card datepickerwrap mt-4 d-flex flex-row justify-content-between">
            <div class="d-flex flex-row gap">
                <div>
                    <div class="mb-1 ml-1 label">{{ translatedLang["Date Range"][selectedLanguage.key] }}</div>
                    <date-range-picker v-model="dateRange" :show-dropdowns="true" opens='right' :autoApply="true"
                        :locale-data="{ format: 'dd mmm yyyy' }" :min-date="minDate" :max-date="maxDate"
                        :ranges="false">
                    </date-range-picker>
                </div>
                <div class="customMultiselectCommon" v-if="platforms.length" style="min-width:170px; max-width:200px">
                    <div class="mb-1 ml-1 label">{{ translatedLang["Platform"][selectedLanguage.key] }}</div>
                    <!-- <select v-model="selectedPlatform" @change="changePlatform"
                        class="form-control text-capitalize platform-select">
                        <option v-for="platform of platforms" :key="platform.platform_link" :value="platform"
                            class="text-capitalize">
                            {{ platform.platform_name.replaceAll("_", " ") }}
                        </option>
                    </select> -->
                    <div class="">
                        <multiselect v-model="selectedPlatform" :custom-label="updateSelectedLabels"
                            @input="changePlatform" :options="platforms" :multiple="false" :searchable="false"
                            placeholder="Select Platform" label="platform_name" track-by="platform_id"
                            :showLabels="false" :close-on-select="true" class="text-capitalize">
                            <template #option="{ option }">
                                <div class="custom-option text-capitalize">
                                    {{ option.platform_name.replaceAll('_', ' ') }}
                                </div>
                            </template>
                        </multiselect>
                    </div>
                </div>
                <div class="customMultiselectCommon" v-if="!productCompare" style="width: 150px;">
                    <div class="mb-1 ml-1 label">{{ translatedLang["Brand"][selectedLanguage.key] }}</div>
                    <!-- <select v-model="selectedGlobalBrand" class="form-control text-capitalize platform-select">
                        <option v-for="brand of allBrands[selectedPlatform.platform_id]" :key="brand.id"
                            :value="brand" class="text-capitalize">
                            {{ brand.label.replaceAll("_", " ") }}
                        </option>
                    </select> -->
                    <multiselect v-model="selectedGlobalBrand"
                        :options="allBrands[selectedPlatform.platform_id] || []" :multiple="false" :searchable="false"
                        placeholder="Select Brand" label="label" track-by="id" :showLabels="false"
                        :close-on-select="true" class="text-capitalize">
                        <!-- <template #option="{ option }">
                                    <div class="custom-option text-capitalize">
                                        {{ option }}
                                    </div>
                                </template> -->
                    </multiselect>
                </div>
                <div v-if="Object.keys(categories).length">
                    <div class="mb-1 ml-1 label">{{ translatedLang["Category"][selectedLanguage.key] }}</div>
                    <div class="customMultiselect" style="width: 250px;">
                        <multiselect v-model="selectedCategory" :options="categories[selectedPlatform.platform_id]"
                            :multiple="false" :searchable="false" placeholder="Select Categories" label="value"
                            track-by="key" :showLabels="false" :close-on-select="true" @input="getAllProducts">
                            <!-- <template #selection="{ values, search, isOpen }">
                                <span class="multiselect__single" v-if="values.length" v-show="!isOpen">
                                    {{ values.length }} options selected
                                </span>
                            </template> -->
                        </multiselect>
                    </div>
                </div>
                <div class="d-flex flex-row align-items-center gap" style="margin-top: 20px;">
                    <!-- Filter and Download Buttons -->
                    <button class="btn primarycolor" @click="applyFilters">
                        {{ translatedLang["Apply Filters"][selectedLanguage.key] }}
                    </button>
                   
                    <button class="btn navigation-btn" v-if="productCompare" @click="goToProductSentiments">
                        {{ translatedLang["Show Sentiments"][selectedLanguage.key] }}
                    </button>
                </div>
            </div>
            <div class="d-flex align-items-center" style="margin-top: 20px;">
                <button @click="downloadReviews" class="btn primarycolor">
                    {{ translatedLang["Download"][selectedLanguage.key] }}
                </button>
                 <button class="btn navigation-btn tw-ml-2" v-if="productCompare" @click="backToTopPerformance">
                        {{ translatedLang["Back"][selectedLanguage.key] }}
                    </button>
            </div>
        </div>
        <div class="card" v-if="productCompare">
            <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex justify-content-start mt-2" v-if="selectedView">
                    <div class="graphHeading pb-2 mr-3">{{ selectedView.view_name }}</div>
                    <div class="cursor-pointer" @click="openViewModal('Edit View')">
                        <img src="../../../public/Icons_SVG/editBtn.svg" style="width: 15px; height: 15px;" />
                    </div>
                    <div class="cursor-pointer ml-3" @click="showDeleteModal = true">
                        <img src="../../../public/Icons_SVG/deleteBtnSvg.svg" style="width: 15px; height: 15px;;" />
                    </div>
                </div>
                <div class="grayedHeading mt-2" v-else>{{ translatedLang["Unsaved View"][selectedLanguage.key] }}</div>
                <div class="d-flex justify-content-end align-items-end">
                    <div style="margin-inline: 0.5rem;">
                        <div class="mb-1 ml-1" style="font-size:14px; font-weight:400; color:#1E1E1E">{{ translatedLang["Select View Name"][selectedLanguage.key] }}</div>
                        <div class="customMultiselect" style="width:250px; margin-bottom: -5px;">
                            <multiselect v-model="selectedView" :options="viewOptions" :multiple="false"
                                :searchable="false" placeholder="Select View" label="view_name" track-by="view_id"
                                :showLabels="false" :close-on-select="true" :allow-empty="false"
                                @input="getSelectedSavedView">
                            </multiselect>
                        </div>
                    </div>
                    <div class="d-flex align-items-end">
                        <button @click="resetSavedView" class="btn primarycolor mr-2 d-flex item-items-center">
                            <span class="newComparisonIcon">
                                <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <path
                                        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z">
                                    </path>
                                </svg>
                            </span>
                            <span>{{ translatedLang["Add New View"][selectedLanguage.key] }}</span>
                        </button>
                    </div>
                    <div class="d-flex justify-content-end align-items-center">
                        <button class="btn navigation-btn" @click="openViewModal('Save View')">
                            <span>{{ translatedLang["Save View"][selectedLanguage.key] }}</span>
                        </button>
                    </div>

                </div>
            </div>
        </div>
        <div>
            <div class="mx-2 position-relative" v-if="!productCompare">
                <div class="card">
                    <ul class="tabs">
                        <li v-for="tab of tabs" :key="tab" @click="switchTab(tab)"
                            :class="{ 'active': tab === selectedTab }">
                            {{  translatedLang[tab][selectedLanguage.key]}}
                        </li>
                    </ul>
                    <button class="btn primarycolor" @click="setProductComparison"
                        style="position: absolute; top: 0.5rem; right: 1rem;">{{  translatedLang["Compare"][selectedLanguage.key]}}</button>
                    <b-row v-if="topProducts.length && topProductsDataShow">
                        <b-col v-for="product of topProducts" :key="product.product_name" class="mt-4">
                            <div class="product-section-card"> dfdsfdf
                                <LogoContainer :imgSrc="product.product_image"
                                    :placeholder="product.product_image ? false : true" :imageHeight="170" />
                                <div class="px-3 py-2 mt-3 d-flex flex-column align-items-between">
                                    <a :href="product.product_link" target="_blank" class="multiline-ellipsis"
                                        :title="product.product_name">{{ product.product_name }}</a>
                                    <!-- On Platform Rating section -->
                                    <div
                                        style="display: flex; flex-direction: column; flex-grow: 1; justify-content: end; position: relative;">
                                        <p class="mb-0 mt-2" style="font-size: 14px; color: #5e5e5e;">{{  translatedLang["On Platform"][selectedLanguage.key]}}</p>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div>
                                                <span style="font-size: 14px; color: #065559; font-weight: 600;">{{
                                                    Number(product.platform_rating).toFixed(2) }}</span>
                                                <span style="font-size: 14px; color: #0655598D; font-weight: 600;">
                                                    /5</span>
                                                <div class="star-tooltip">
                                                    <div class="container">
                                                        <div class="d-inline-flex">
                                                            <IconStar v-for="i in maxRating" :key="i" class="star" />
                                                        </div>
                                                        <div class="overlay"
                                                            :style="{ width: `${100 - percentage(product.platform_rating)}%` }" />
                                                    </div>
                                                    
                                                    <div class="star-tooltiptext" > ddsfdsfds
                                                        <div v-for="val, key, index of product.ratings_breakdown.platform"
                                                            class="rating-row" :key="key">
                                                            <div style="width: 10%;"
                                                                class="d-inline-flex align-items-center justify-content-between">
                                                                <span class="mr-1">{{ key.split(" ")[0] }}</span>
                                                                <IconStar class="star text-center" />
                                                            </div>
                                                            <span class="ratings-group">
                                                                <span class="inactive-ratings-bar"></span>
                                                                <span class="active-ratings-bar"
                                                                    :style="{ width: `${val.percent}%`, 'background-color': `${barColors[index]}` }"></span>
                                                            </span>
                                                            <div style="color: #5E5E5E; width: 35%;">
                                                                {{ val.count }} ({{ val.percent }}%)</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style="font-size: 14px; color: #5E5E5E; font-weight: 600;">{{
                                                product.platform_rating_count }}
                                                {{ product.platform_rating_count !== 'NA' ? 'Reviews' : '' }}</div>
                                        </div>
                                    </div>
                                    <!-- On Weavr Rating section -->
                                    <div
                                        style="display: flex; flex-direction: column; flex-grow: 1; justify-content: end; position: relative;">
                                        <p class="mb-0 mt-2" style="font-size: 14px; color: #5e5e5e;">{{  translatedLang["On Weavr"][selectedLanguage.key]}}</p>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div>
                                                <span style="font-size: 14px; color: #065559; font-weight: 600;">{{
                                                    product.rating.toFixed(2) }}</span>
                                                <span style="font-size: 14px; color: #0655598D; font-weight: 600;">
                                                    /5</span>
                                                <div class="star-tooltip">
                                                    <div class="container">
                                                        <div class="d-inline-flex">
                                                            <IconStar v-for="i in maxRating" :key="i" class="star" />
                                                        </div>
                                                        <div class="overlay"
                                                            :style="{ width: `${100 - percentage(product.rating)}%` }" />
                                                    </div>
                                                    <div class="star-tooltiptext">
                                                        <div v-for="val, key, index of product.ratings_breakdown.weavr"
                                                            class="rating-row" :key="key">
                                                            <div style="width: 10%;"
                                                                class="d-inline-flex align-items-center justify-content-between">
                                                                <span class="mr-1">{{ key.split(" ")[0] }}</span>
                                                                <IconStar class="star text-center" />
                                                            </div>
                                                            <span class="ratings-group">
                                                                <span class="inactive-ratings-bar"></span>
                                                                <span class="active-ratings-bar"
                                                                    :style="{ width: `${val.percent}%`, 'background-color': `${barColors[index]}` }"></span>
                                                            </span>
                                                            <div style="color: #5E5E5E; width: 35%;">
                                                                {{ val.count }} ({{ val.percent }}%)</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style="font-size: 14px; color: #5E5E5E; font-weight: 600;">{{
                                                product.rating_count }}
                                                {{  translatedLang["Reviews"][selectedLanguage.key]}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row v-else-if="!topProductsDataShow && topProductsLoaderForTabs"
                        class="onLoadingData mt-3 mx-1">{{  translatedLang["Loading"][selectedLanguage.key]}}...</b-row>
                    <b-row v-else class="noData mt-3 mx-1">{{  translatedLang["No Data"][selectedLanguage.key]}}</b-row>
                </div>

                <!-- Product Selection Filter -->
                <div class="card mt-3 d-flex flex-row gap" style="z-index: 9 !important;">
                    <div style="width: 20%;">
                        <div class="mb-1 ml-1 label">{{  translatedLang["Product"][selectedLanguage.key]}}</div>
                        <Treeselect class="text-capitalize" v-model="selectedGlobalProduct"
                            :options="categoryWiseProducts[selectedPlatform.platform_id]" placeholder="Select Product"
                            :show-count="true" :multiple="false" :clearable="false" :disableBranchNodes="true"
                            :searchable="true" openDirection="top">
                            <span slot="noResult">{{  translatedLang["No elements found"][selectedLanguage.key]}}</span>
                            <label slot="option-label" slot-scope="{node, labelClassName}" :title="node.label" :class="{
                                'text-truncate d-flex align-items-center text-capitalize': !node.isBranch,
                                'tree-leaf': node.isBranch
                            }">{{ node.label }}</label>
                        </Treeselect>
                    </div>
                    <div class="d-flex flex-row align-items-center gap" style="margin-top: 20px;">
                        <!-- Filter and Download Buttons -->
                        <button class="btn primarycolor" @click="getSelectedProduct">
                            {{  translatedLang["Apply Filters"][selectedLanguage.key]}}
                        </button>
                    </div>
                </div>

                <!-- Selected Product Analytics -->

                <div class="card" v-if="Object.keys(globalProductReviews).length">
                    <b-row no-gutters v-if="Object.keys(globalProductReviews).length">
                        <b-col cols="8" class="vertical-divider pr-3">
                            <BrandIndicator level="product" :indicatorName="globalProductName.value"
                                :brandIndicators="globalProductMarketShare" />
                            <div>
                                <div class="my-4 d-flex flex-row gap">
                                    <!-- Button Groups for date filtering -->
                                    <button type="button" v-for="filterState of reviewFilterState" :key="filterState"
                                        class="section-button"
                                        :class="selectedFilterState === filterState ? 'active-button' : ''"
                                        @click="filterCustomDate(filterState)">
                                        {{ translatedLang[filterState][selectedLanguage.key] }}
                                    </button>
                                </div>
                                <b-row class="mt-4" no-gutters>
                                    <b-col cols="6" class="pr-3">
                                        <div class="section-card"
                                            v-if="Object.keys(globalProductReviews.ratings).length">
                                            <ReviewsAndRatings :ratingsData="globalProductReviews.ratings" />
                                        </div>
                                        <div v-else class="section-card">
                                            <p class="heading">{{ translatedLang["Overall Rating"][selectedLanguage.key] }}</p>
                                            <div class="noData">{{ translatedLang["No Data"][selectedLanguage.key] }}</div>
                                        </div>
                                    </b-col>
                                    <b-col cols="6">
                                        <div class="section-card"
                                            v-if="Object.keys(globalProductSentiments.sentiment).length">
                                            <Sentiments :sentimentsData="globalProductSentiments.sentiment"
                                                :navigation="true"
                                                @navigate-to-sentiment-details="navigateWordCloud('sentiments-detail')" />
                                        </div>
                                        <div v-else>
                                            <p class="heading">{{ translatedLang["Customer Sentiments"][selectedLanguage.key] }}</p>
                                            <div class="noData">{{ translatedLang["No Data"][selectedLanguage.key] }}</div>
                                        </div>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-3">
                                    <b-col cols="12">
                                        <PerformanceChart heading="Brand" :showTabs="true"
                                            :performanceData="globalProductReviews.performance_ratings"
                                            :performanceRatingsData="performanceRatingsData" />
                                    </b-col>
                                </b-row>
                            </div>
                        </b-col>
                        <b-col cols="4" class="pl-3"
                            style="background: linear-gradient(180deg, rgba(255, 255, 255, 0) 94.69%, rgba(14, 14, 14, 0.1) 100%);">
                            <LogoContainer :brandContainer="true" :imgSrc="globalProductImage" />
                            <div class="mt-2">
                                <div class="review-heading">
                                    <div id="border"></div>
                                    <div id="heading">{{ translatedLang["Review Summary"][selectedLanguage.key] }}</div>
                                </div>
                                <div class="section-card my-3 px-4 py-3">
                                    <div style="font-size: 15px; font-weight: 600; letter-spacing: 0;">{{ translatedLang["What customers say"][selectedLanguage.key] }}:
                                    </div>
                                    <div class="py-2">
                                        {{ globalProductAISummary }}
                                    </div>
                                    <div style="font-family: Heebo; color: #5E5E5E;" class="pb-2">
                                        {{ translatedLang["AI-generated from the text of customer reviews"][selectedLanguage.key] }}
                                    </div>
                                </div>
                            </div>
                            <LatestReviews :latestReviews="globalProductReviews.reviews" parentClasses="mt-2" />
                        </b-col>
                    </b-row>
                    <section id="sentiments-detail" class="mt-3">
                        <b-row no-gutters v-if="Object.keys(globalProductSentiments.word_clowd).length">
                            <b-col cols="6" class="pr-2">
                                <div class="section-card" v-if="Object.keys(globalProductSentiments.word_clowd).length">
                                    <div class="d-flex justify-content-between align-items-center heading">
                                        <p class="mb-0">{{ translatedLang["Positive Sentiments"][selectedLanguage.key] }}</p>
                                        <div class="customSelect">
                                            <select class="form-control text-capitalize platform-select"
                                                v-model="selectedPositiveCloudLimit">
                                                <option value="10">10</option>
                                                <option value="25">25</option>
                                                <option value="50">50</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div v-if="globalProductSentiments.word_clowd.positive.length">
                                        <WordCloud
                                            :cloudData="globalProductSentiments.word_clowd.positive.slice(0, selectedPositiveCloudLimit)"
                                            color="#065559" @analyse-keyword="openPositiveModal" />
                                    </div>
                                    <div v-else class="noData">
                                        {{ translatedLang["No Data"][selectedLanguage.key] }}
                                    </div>
                                </div>
                            </b-col>
                            <b-col cols="6" class="pl-1">
                                <div class="section-card" v-if="Object.keys(globalProductSentiments.word_clowd).length">
                                    <div class="d-flex justify-content-between align-items-center heading">
                                        <p class="mb-0">{{ translatedLang["Negative Sentiments"][selectedLanguage.key] }}</p>
                                        <div class="customSelect">
                                            <select class="form-control text-capitalize platform-select"
                                                v-model="selectedNegativeCloudLimit">
                                                <option value="10">10</option>
                                                <option value="25">25</option>
                                                <option value="50">50</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div v-if="globalProductSentiments.word_clowd.negative.length">
                                        <WordCloud
                                            :cloudData="globalProductSentiments.word_clowd.negative.slice(0, selectedNegativeCloudLimit)"
                                            color="#FD5542" @analyse-keyword="openNegativeModal" />
                                    </div>
                                    <div v-else class="noData">
                                        {{ translatedLang["No Data"][selectedLanguage.key] }}
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </section>
                    <b-row no-gutters v-if="Object.keys(globalProductSentiments).length">
                        <b-col cols="8" class="pb-4 pr-2">
                            <div class="section-card mt-3">
                                <p class="heading">{{ translatedLang["All Sentiments"][selectedLanguage.key] }}</p>
                                <div class="thin-scroller">
                                    <table class="w-100 mt-4" id="product-sentiments-table"
                                        v-if="globalProductSentiments.table.length">
                                        <thead>
                                            <tr>
                                                <th>{{ translatedLang["Keyword"][selectedLanguage.key] }}</th>
                                                <th>{{ translatedLang["Frequency"][selectedLanguage.key] }}</th>
                                                <th>{{ translatedLang["Score"][selectedLanguage.key] }}</th>
                                                <th>{{ translatedLang["Total Frequency"][selectedLanguage.key] }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="row, index of globalProductSentiments.table"
                                                :data-row-index="index">
                                                <td class="keyword" role="button" tabindex="0"
                                                    @click="openModal(row.word_new)">
                                                    {{ row.word_new.value }}
                                                </td>
                                                <td class="text-center">
                                                    <div
                                                        style="font-family: Heebo; font-size: 16px; font-weight: 400; color: #065559;">
                                                        {{ formatNumber(row.positive_frequency) }}
                                                    </div>
                                                    <div
                                                        style="font-family: Heebo; font-size: 16px; font-weight: 400; color: #D90000;">
                                                        {{ formatNumber(row.negative_frequency) }}
                                                    </div>
                                                </td>
                                                <td class="text-center">
                                                    <div
                                                        class="d-flex justify-content-center align-items-center gauge-container">
                                                        <GaugeChart :rawData="row" />
                                                    </div>
                                                </td>
                                                <td>{{ row.positive_frequency + row.negative_frequency }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div v-else class="noData">{{ translatedLang["No Data"][selectedLanguage.key] }}</div>
                                </div>
                            </div>
                        </b-col>
                        <b-col cols="4" class="pl-1">
                            <div class="section-card my-3" style="height: 1000px; ">
                                <p class="heading">{{ translatedLang["Insights"][selectedLanguage.key] }}</p>
                                <div style="height: 1000px; overflow-y: auto" class="thin-scrollerBar pr-1 pt-1">

                                    <div class="inSightsContainer d-flex"
                                        v-for="(insight, index) in viewMostReviewsInsightsData" :key="'most' + index">
                                        <div class="col-1 d-flex justify-content-center align-items-center flex-column">
                                            <p class="mb-0 px-2" style="color: #00555A; font-weight: 400;">{{ new
                                                Date(dateRange.endDate).toLocaleString('en-US', {
                                                    month: 'short'
                                                }) }}
                                            </p>
                                            <p class="mb-0 px-2"
                                                style="font-size: 20px;font-weight: 600; color: #5E5E5E;">{{
                                                    new Date(dateRange.endDate).getDate() }}</p>
                                        </div>
                                        <div class="col-11 pt-2 pb-2">
                                            <p class="insightsContent mb-2" v-html="insight"></p>
                                        </div>
                                    </div>
                                    <!-- <div class="inSightsContainer d-flex mt-3"
                                        v-for="(insight, index) in viewWorstReviewsInsightsData" :key="'worst' + index">
                                        <div class="col-1 d-flex justify-content-center align-items-center flex-column">
                                            <p class="mb-0 px-2" style="color: #00555A; font-weight: 400;">{{ new
                                                Date(dateRange.endDate).toLocaleString('en-US', {
                                                    month: 'short'
                                                }) }}
                                            </p>
                                            <p class="mb-0 px-2"
                                                style="font-size: 20px;font-weight: 600; color: #5E5E5E;">{{
                                                    new Date(dateRange.endDate).getDate() }}</p>
                                        </div>
                                        <div class="col-11 pt-2 pb-2">
                                            <p class="insightsContent mb-2" v-html="insight"></p>
                                        </div>
                                    </div> -->
                                    <div class="inSightsContainer d-flex mt-3"
                                        v-for="(insight, index) in viewKeywordInsightsData" :key="'keyword' + index">
                                        <div class="col-1 d-flex justify-content-center align-items-center flex-column">
                                            <p class="mb-0 px-2" style="color: #00555A; font-weight: 400;">{{ new
                                                Date(dateRange.endDate).toLocaleString('en-US', {
                                                    month: 'short'
                                                }) }}
                                            </p>
                                            <p class="mb-0 px-2"
                                                style="font-size: 20px;font-weight: 600; color: #5E5E5E;">{{
                                                    new Date(dateRange.endDate).getDate() }}</p>
                                        </div>
                                        <div class="col-11 pt-2 pb-2">
                                            <p class="insightsContent mb-2" v-html="insight"></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </div>
            <div class="ml-1 mr-2" v-else-if="productCompare">
                <b-row no-gutters class="mb-4">
                    <b-col cols="4">
                        <div>
                            <div class="compare-card">
                                <b-row>
                                    <b-col>
                                        <LogoContainer :imgSrc="comparisonList[0].img"
                                            :placeholder="comparisonList[0].img ? false : true" :imageHeight="170" />
                                    </b-col>
                                    <b-col class="px-2 d-flex flex-column justify-content-between" style="gap: 8px">
                                        <div class="mb-4 mt-2" style="font-size: 16px;">
                                            <span class="font-weight-bold text-capitalize" style="color: #065559;">{{
                                                selectedCategory.value }}:
                                            </span>
                                            <span class="text-capitalize">{{
                                                comparisonList[0].selectedProduct &&
                                                comparisonList[0].selectedProduct.split("+")[0]
                                            }}</span>
                                            <div class="mt-2" style="color: #5e5e5e;">{{
                                                comparisonList[0].selectedProduct &&
                                                    comparisonList[0].selectedProduct.split("+")[0]
                                                    ===
                                                    client
                                                    ? 'Primary Product'
                                                    : 'Competitor Product'
                                            }}</div>
                                        </div>
                                        <div style="width: 95%;">
                                            <Treeselect v-if="allProducts[selectedPlatform.platform_id].length"
                                                class="text-capitalize" v-model="comparisonList[0].selectedProduct"
                                                :options="allProducts[selectedPlatform.platform_id]"
                                                placeholder="Select Product" :show-count="true" :multiple="false"
                                                @input="updateComparisonData(0)" :clearable="false"
                                                :disableBranchNodes="true" :searchable="true">
                                                <span slot="noResult">{{ translatedLang["No elements found"][selectedLanguage.key] }}</span>
                                                <label slot="option-label" slot-scope="{node, labelClassName}"
                                                    :title="node.label" :class="{
                                                        'text-truncate d-flex align-items-center text-capitalize': !node.isBranch,
                                                        'tree-leaf': node.isBranch
                                                    }">{{ node.label }}</label>
                                            </Treeselect>
                                        </div>
                                    </b-col>
                                </b-row>
                                <div class="px-2">
                                    <ReviewsAndRatings v-if="Object.keys(comparisonList[0].ratingsData).length"
                                        :ratingsData="comparisonList[0].ratingsData" />
                                </div>
                            </div>
                            <!-- <div class="compare-card my-3 px-2 py-3"
                                v-if="Object.keys(comparisonList[0].sentiments).length">
                                <Sentiments :sentimentsData="comparisonList[0].sentiments.sentiment" :navigation="true"
                                    @navigate-to-sentiment-details="navigateWordCloud('word-cloud-0')" />
                            </div> -->
                            <!-- <div id="word-cloud-0" class="compare-card my-3 px-2 py-3"
                                v-if="Object.keys(comparisonList[0].sentiments).length">
                                <div>
                                    <p class="heading">{{ translatedLang["Positive Sentiments"][selectedLanguage.key] }}</p>
                                    <WordCloud v-if="comparisonList[0].sentiments.word_clowd.positive.length"
                                        :cloudData="comparisonList[0].sentiments.word_clowd.positive" color="#065559" />
                                    <div v-else style="height: 350px;">
                                        <div class="px-4 py-2" style="color: var(--red-80);">{{ translatedLang["No Data"][selectedLanguage.key] }}</div>
                                    </div>
                                </div>
                            </div> -->
                            <!-- <div class="compare-card mt-3 px-2 py-3"
                                v-if="Object.keys(comparisonList[0].sentiments).length">
                                <div>
                                    <p class="heading">{{ translatedLang["Negative Sentiments"][selectedLanguage.key] }}</p>
                                    <WordCloud v-if="comparisonList[0].sentiments.word_clowd.negative.length"
                                        :cloudData="comparisonList[0].sentiments.word_clowd.negative" color="#FD5542" />
                                    <div v-else style="height: 350px;">
                                        <div class="px-4 py-2" style="color: var(--red-80);">{{ translatedLang["No Data"][selectedLanguage.key] }}</div>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </b-col>
                    <b-col cols="8">
                        <div class="d-flex w-100 px-1 thin-scroller" style="overflow-x: auto; min-height: 100%;">
                            <div v-for="index in 5" class="mx-1" :id="'compare-card-' + index" style="min-width: 50%;"
                                v-if="comparisonList[index]">
                                <div class="compare-card">
                                    <b-row>
                                        <b-col>
                                            <LogoContainer :imgSrc="comparisonList[index].img"
                                                :placeholder="comparisonList[index].img ? false : true"
                                                :imageHeight="170" />
                                        </b-col>
                                        <b-col class="px-2 d-flex flex-column justify-content-between position-relative"
                                            style="gap: 8px">
                                            <div class="mb-4 mt-2" style="font-size: 16px;">
                                                <span class="font-weight-bold text-capitalize"
                                                    style="color: #065559;">{{
                                                        selectedCategory.value }}:
                                                </span>
                                                <span class="text-capitalize">{{
                                                    comparisonList[index].selectedProduct &&
                                                    comparisonList[index].selectedProduct.split("+")[0]
                                                    }}</span>
                                                <div class="mt-2" style="color: #5e5e5e;">{{
                                                    comparisonList[index].selectedProduct &&
                                                        comparisonList[index].selectedProduct.split("+")[0]
                                                        ===
                                                        client
                                                        ? 'Primary Product'
                                                        : 'Competitor Product'
                                                }}</div>
                                            </div>
                                            <div style="width: 95%;">
                                                <Treeselect v-if="allProducts[selectedPlatform.platform_id].length"
                                                    class="text-capitalize"
                                                    v-model="comparisonList[index].selectedProduct"
                                                    :options="allProducts[selectedPlatform.platform_id]"
                                                    placeholder="Select Product" :show-count="true" :multiple="false"
                                                    @input="updateComparisonData(index)" :clearable="false"
                                                    :disableBranchNodes="true" :searchable="true">
                                                    <span slot="noResult">{{ translatedLang["No elements found"][selectedLanguage.key] }}</span>
                                                    <label slot="option-label" slot-scope="{node, labelClassName}"
                                                        :title="node.label" :class="{
                                                            'text-truncate d-flex align-items-center text-capitalize': !node.isBranch,
                                                            'tree-leaf': node.isBranch
                                                        }">{{ node.label }}</label>
                                                </Treeselect>
                                            </div>
                                            <div class="close-card" @click="removeCompareCard(index)">
                                                <i class="fa fa-close"></i>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <div class="px-2">
                                        <ReviewsAndRatings v-if="Object.keys(comparisonList[index].ratingsData).length"
                                            :ratingsData="comparisonList[index].ratingsData" />
                                    </div>
                                </div>
                                <div class="compare-card my-3 px-2 py-3"
                                    v-if="Object.keys(comparisonList[index].sentiments).length">
                                    <Sentiments :sentimentsData="comparisonList[index].sentiments.sentiment"
                                        :navigation="true"
                                        @navigate-to-sentiment-details="navigateWordCloud(`word-cloud-${index}`)" />
                                </div>
                                <div :id="'word-cloud-' + index" class="compare-card my-3 px-2 py-3"
                                    v-if="Object.keys(comparisonList[index].sentiments).length">
                                    <div>
                                        <p class="heading">{{ translatedLang["Positive Sentiments"][selectedLanguage.key] }}</p>
                                        <WordCloud v-if="comparisonList[index].sentiments.word_clowd.positive.length"
                                            :cloudData="comparisonList[index].sentiments.word_clowd.positive"
                                            color="#065559" />
                                        <div v-else style="height: 350px;">
                                            <div class="px-4 py-2" style="color: var(--red-80);">{{ translatedLang["No Data"][selectedLanguage.key] }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="compare-card mt-3 px-2 py-3"
                                    v-if="Object.keys(comparisonList[index].sentiments).length">
                                    <div>
                                        <p class="heading">{{ translatedLang["Negative Sentiments"][selectedLanguage.key] }}</p>
                                        <WordCloud v-if="comparisonList[index].sentiments.word_clowd.negative.length"
                                            :cloudData="comparisonList[index].sentiments.word_clowd.negative"
                                            color="#FD5542" />
                                        <div v-else style="height: 350px;">
                                            <div class="px-4 py-2" style="color: var(--red-80);">{{ translatedLang["No Data"][selectedLanguage.key] }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="comparisonList.length < 5" class="d-flex"
                                :style="comparisonList.length < 2 ? 'min-width: 90%;' : 'min-width: 45%;'">
                                <div class="add-comparison mx-1 w-100">
                                    <div class="plus-icon" @click="prepareComparisonList">
                                        +
                                    </div>
                                    <div style="font-size:16px; font-weight: 500;">
                                        {{ translatedLang["Add Product"][selectedLanguage.key] }}
                                    </div>
                                </div>
                                <div class="add-comparison" v-if="comparisonList.length < 2"
                                    :style="comparisonList.length === 2 ? 'min-width: 50%' : 'min-width: 45%'">
                                    <div class="plus-icon" @click="prepareComparisonList">
                                        +
                                    </div>
                                    <div style="font-size:16px; font-weight: 500;">
                                        {{ translatedLang["Add Product"][selectedLanguage.key] }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>

                <div class="mx-2 card" v-if="Object.keys(reviewCountChart).length">
                    <div class="d-flex justify-content-between align-items-center card-heading">
                        <p>       {{ translatedLang["Number of Reviews"][selectedLanguage.key] }}</p>
                        <b-button-toolbar aria-label="Toolbar with buttons group">
                            <b-form-radio-group class="mr-3 radiohide" id="radiosBtn" buttons
                                button-variant="outline-secondary" v-model="reviewCountInterval"
                                @change="changeCountInterval" name="radiosBtn">
                                <b-form-radio class="mx-0" value="day">{{ translatedLang["Day"][selectedLanguage.key] }}</b-form-radio>
                                <b-form-radio class="mx-0" value="week">{{ translatedLang["Week"][selectedLanguage.key] }}</b-form-radio>
                                <b-form-radio class="mx-0" value="month">{{ translatedLang["Month"][selectedLanguage.key] }}</b-form-radio>
                            </b-form-radio-group>
                        </b-button-toolbar>
                    </div>
                    <MultiLineChart :rawData="reviewCountChart" legendVerticalAlign="bottom"
                        legendHorizontalAlign="left" />
                </div>
                <div class="mx-2 card" v-if="vocData.length">
                    <div class="d-flex justify-content-between align-items-center card-heading">
                        <p>{{ translatedLang["Voice of Customers"][selectedLanguage.key] }}</p>
                    </div>
                    <b-row>
                        <b-col cols="5" v-if="vocPieChart.length" style="border-right: 1px solid #D9D9D9;">
                            <ThinPie :rawData="vocPieChart" :noTotalText="true" innerSize="30%" :formatLegend="false"
                                :dataLabel="true" />
                        </b-col>
                        <b-col cols="7" v-if="Object.keys(vocStack).length">
                            <StackChart :rawData="vocStack" />
                        </b-col>
                    </b-row>
                </div>
            </div>
        </div>
        <b-modal v-model="keywordModal" size="xl" :title="modalTitle" @hidden="resetModal">
            <div class="modal-control-panel mt-3">
                <ul>
                    <li v-for="tab of modalTabs" :key="tab" @click="selectedModalTab = tab"
                        :class="{ 'selected-tab': tab === selectedModalTab }">{{ translatedLang[tab][selectedLanguage.key]}}</li>
                </ul>
                <div class="d-flex" style="margin-top: -16px;">
                    <b-button-toolbar aria-label="Toolbar with buttons group"
                        v-show="selectedModalTab === 'Frequency' || selectedModalTab === 'Score' || selectedModalTab === 'Review Count'">
                        <b-form-radio-group class="mr-3 radiohide" id="radiosBtn" buttons
                            button-variant="outline-secondary" @change="updateSentimentData" v-model="keywordInterval"
                            name="radiosBtn">
                            <b-form-radio class="mx-0" value="month">{{ translatedLang["Month"][selectedLanguage.key]}}</b-form-radio>
                            <b-form-radio class="mx-0" value="week">{{ translatedLang["Week"][selectedLanguage.key]}}</b-form-radio>
                        </b-form-radio-group>
                    </b-button-toolbar>
                    <date-range-picker v-model="modalDateRange" :show-dropdowns="true" opens='right' :autoApply="true"
                        :locale-data="{ format: 'dd mmm yyyy' }" :min-date="minDate" :max-date="maxDate" :ranges="false"
                        @update="updateModal">
                    </date-range-picker>
                </div>
            </div>
            <div v-if="Object.keys(keywordWiseSentiments).length">
                <KeywordModalCard :selectedTab="selectedModalTab" :keywordReview="keywordWiseReviews"
                    :keywordSentiment="keywordWiseSentiments" :keywordTreeData="keywordTreeData"
                    @filter-reviews="filterReviews" @toggle-node="toggleTreeNode" />
            </div>
            <!-- <div class="modal-control-panel">
                <h6>{{ selectedKeywordChartMetric.label }}</h6>
                <div class="d-flex" style="gap: 6px;">
                    <select class="customselect" v-model="selectedKeywordChartMetric">
                        <option v-for="metric of keywordChartMetric" :key="metric.key" :value="metric">{{
                            metric.label }}</option>
                    </select>
                    <b-button-toolbar aria-label="Toolbar with buttons group">
                        <b-form-radio-group class="mr-3 radiohide" id="radiosBtn" buttons
                            button-variant="outline-secondary" @change="updateSentimentData" v-model="keywordInterval"
                            name="radiosBtn">
                            <b-form-radio class="mx-0" value="month">Month</b-form-radio>
                            <b-form-radio class="mx-0" value="week">Week</b-form-radio>
                        </b-form-radio-group>
                    </b-button-toolbar>
                    <date-range-picker style="width: 200%;" v-model="modalDateRange" :show-dropdowns="true" opens='left'
                        :autoApply="true" :locale-data="{ format: 'dd mmm yyyy' }" :min-date="minDate"
                        :max-date="maxDate" :ranges="false" @update="updateModal">
                    </date-range-picker>
                </div>
            </div>
            <div v-if="Object.keys(keywordWiseSentiments).length">
                <KeywordModalCard :keywordReview="keywordWiseReviews" :keywordSentiment="keywordWiseSentiments"
                    :chartKey="selectedKeywordChartMetric.key" @filter-reviews="filterReviews" />
            </div> -->
        </b-modal>
        <b-modal size="md" class="customModal" hide-footer style="z-index: 3000 !important; text-transform: capitalize"
            v-model="showViewModal" :title="viewModalName">
            <div class="customMultiselect" v-if="viewModalName === 'Save View'">
                <multiselect v-model="selectedModalView" :options="modalViewOptions" :multiple="false"
                    :searchable="false" placeholder="Select View" label="view_name" track-by="view_id"
                    :showLabels="false" :close-on-select="true" :allow-empty="false">
                </multiselect>
            </div>
            <input required type="text" v-model="newViewName" class="text-capitalize customInput px-2"
                v-show="viewModalName === 'Edit View' || (viewModalName === 'Save View' && selectedModalView.view_id === 'add_new')" />
            <div class="d-flex justify-content-end align-items-center mt-3">
                <button class="btn navigation-btn" :disabled="spinLoader" @click="saveCompareView">
                    <b-spinner small class="mr-2" v-if="spinLoader"></b-spinner>
                    <span>{{ translatedLang["Save View"][selectedLanguage.key]}}</span>
                </button>
            </div>
        </b-modal>
        <b-modal title="Delete View" v-model="showDeleteModal" class="container-modal-ASIN">
            <div class="modal-delete-content d-flex align-items-start mb-2">
                <div class="delete-alert text-center rounded-circle px-2 mr-3">&#9888;</div>
                <div>{{ translatedLang["delete this View"][selectedLanguage.key] }}.<br>{{ translatedLang["Are you sure"][selectedLanguage.key] }} ?</div>
            </div>
            <div class="d-flex justify-content-end">
                <b-button @click="showDeleteModal = false" class="btn primarycolor">{{ translatedLang["No"][selectedLanguage.key] }}, {{ translatedLang["Keep It"][selectedLanguage.key] }}.</b-button>
                <button @click="deleteView" :disabled="spinLoader"
                    class="btn primarycolor px-3 py-1 ml-2 d-flex align-items-center delete-viewBtn"
                    style="background-color: var(--red)">
                    <b-spinner small class="mr-2" v-if="spinLoader"></b-spinner>
                    <span>{{ translatedLang["Yes"][selectedLanguage.key] }}, {{ translatedLang["Delete"][selectedLanguage.key] }}!</span>
                </button>
            </div>
        </b-modal>
    </div>
</template>
<script>
import moment from 'moment';
import Multiselect from "vue-multiselect";
import LogoContainer from './Components/LogoContainer.vue';
import IconStar from '../../assets/IconStar.vue';
import BrandIndicator from './Components/BrandIndicator.vue';
import ReviewsAndRatings from './Components/ReviewsAndRatings.vue';
import Sentiments from './Components/Sentiments.vue';
import PerformanceChart from './Components/PerformanceChart.vue';
import LatestReviews from './Components/LatestReviews.vue';
import GaugeChart from '../commonCharts/GaugeChart.vue';
import KeywordModalCard from './Components/KeywordModalCard.vue';
import WordCloud from '../commonCharts/WordCloud.vue';
import MultiLineChart from '../commonCharts/MultiLineChart.vue';
import ThinPie from '../commonCharts/ThinPie.vue';
import StackChart from '../commonCharts/StackChart.vue';
import Loader from '../Components/Loader.vue';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { mapState, mapActions } from "vuex";

export default {
    name: "ProductReviews",
    components: {
        Treeselect,
        Loader,
        Multiselect,
        LogoContainer,
        BrandIndicator,
        LatestReviews,
        PerformanceChart,
        KeywordModalCard,
        GaugeChart,
        IconStar,
        ReviewsAndRatings,
        Sentiments,
        WordCloud,
        MultiLineChart,
        ThinPie,
        StackChart
    },
    data() {
        return {
            loader: false,
            reviewLoader: false,
            countLoader: false,
            spinLoader: false,
            savedViewLoader: false,
            vocLoader: false,
            dateRange: {
                startDate: moment().subtract(3, 'months').format("YYYY-MM-DD"),
                endDate: moment().format("YYYY-MM-DD")
                // startDate: "2022-04-11",  // Fixed start date
                // endDate: "2023-04-30"
            },
            modalDateRange: {
                startDate: moment().subtract(3, 'months').format("YYYY-MM-DD"),
                endDate: moment().format("YYYY-MM-DD")
            },
            maxDate: new Date(),
            minDate: new Date(moment().subtract(3, 'years')),
            client: JSON.parse(localStorage.reviewUserData).data.client,
            featureId: JSON.parse(localStorage.reviewUserData).data.feature_id_map.Reviews_And_Ratings,
            platforms: [],
            selectedPlatform: "",
            // selectedProductPlatform: "",
            categories: {},
            selectedCategory: {},
            selectedProductCategory: null,
            tabs: ['Top Reviewed', 'Worst Reviewed', 'Most Reviewed', 'Least Reviewed'],
            selectedTab: "Top Reviewed",
            topProducts: [],
            tabKeyMapper: {
                'Most Reviewed': {
                    keyVal: 'count',
                    keyType: 'increasing'
                },
                'Least Reviewed': {
                    keyVal: 'count',
                    keyType: 'decreasing'
                },
                'Top Reviewed': {
                    keyVal: 'ratings',
                    keyType: 'increasing'
                },
                'Worst Reviewed': {
                    keyVal: 'ratings',
                    keyType: 'decreasing'
                }
            },
            maxRating: 5,
            productCompare: false,
            availableProducts: localStorage.demo_voc_product_list && JSON.parse(localStorage.demo_voc_product_list),
            filteredProducts: [],
            comparisonList: [],
            numberOfReviews: [],
            reviewCountChart: {},
            reviewCountInterval: 'week',
            vocData: [],
            vocPieChart: [],
            vocStack: {},
            allProducts: [],
            defaultComparisonProduct: null,
            savedViews: [],
            viewOptions: [],
            selectedView: "",
            showViewModal: false,
            viewModalName: "",
            showDeleteModal: false,
            newViewName: "",
            selectedModalView: {
                view_id: 'add_new',
                view_name: 'Add New'
            },
            modalViewOptions: [],
            allBrands: {},
            selectedGlobalBrand: {},
            selectedGlobalProduct: null,
            globalProductReviews: {},
            globalProductSentiments: {},
            globalProductAISummary: "",
            globalProductName: "",
            globalProductImage: "",
            globalProductMarketShare: {},
            categoryWiseProducts: {},
            reviewFilterState: ['Overview', 'Last Week', 'Last Month', 'Last Year'],
            selectedFilterState: 'Overview',
            keywordModal: false,
            selectedModalKeyword: "",
            modalTitle: "",
            keywordWiseReviews: [],
            keywordWiseSentiments: {},
            keywordTreeData: {},
            modalTabs: [
                "Reviews",
                "Frequency",
                // "Score",
                "Review Count",
                // "Tree Structure",
                "Contribution tree"
            ],
            selectedModalTab: "Reviews",
            keywordInterval: 'month',
            selectedPositiveCloudLimit: 10,
            selectedNegativeCloudLimit: 10,
            // product insights 
            viewKeywordInsightsData: '',
            viewMostReviewsInsightsData: '',
            viewWorstReviewsInsightsData: '',
            performanceRatingsData: [],
            brandNameFromLogin: JSON.parse(localStorage.reviewUserData).data.brand_name[0],
            topProductsDataShow: false,
            topProductsLoaderForTabs: true,
            barColors: ['#065559', '#6AB7A8', '#B5DBD4', '#9ABABC', '#DAEDE9', '#76999A'],
            loaderUpdated: false,
            showNoDataImgForUser: false
        }
    },
    mounted() {
        const data=localStorage.getItem('reviewUserData');
        if(data){
            const res=JSON.parse(data);
            if(res.data.brand_name[0]=="colgate"){
                this.dateRange={
                    startDate: moment().subtract(3, 'years').format("YYYY-MM-DD"),
                    endDate: moment().format("YYYY-MM-DD")
                }
            }
        }
        this.getLastUpdatedDates();
        this.$store.dispatch("DemoStore/setTimeStamp", ""); //using for clear the last updated time stamp
        this.$store.dispatch("DemoStore/setUpdatedStatus", '')
    },
    computed: {
    ...mapState("DemoStore", ["selectedLanguage", "translatedLang"]),
  },
    methods: {
        ...mapActions("DemoStore", [
      "setSelectedLanguage",
      "initializeTranslation",
    ]),
        getLastUpdatedDates() {
            this.loaderUpdated = true;
            const url = `/api/v2/india_clients/last_update?client=${this.client}&feature_id=${this.featureId}`;
            this.$http.get(url).then((response) => {
                if (response.body.data.reviews_and_ratings) {
                    this.showNoDataImgForUser = false
                    this.getPlatformsAndCategories();
                    this.loaderUpdated = false;
                } else {
                    this.showNoDataImgForUser = true;
                    this.loaderUpdated = false;
                }

            }).catch((err) => {
                this.loaderUpdated = false;
                console.log("err", err);
            }).finally(() => {
                this.loaderUpdated = false;
            });
        },
        percentage(rating) {
            return (rating / this.maxRating) * 100;
        },
        navigateWordCloud(id) {
            document.getElementById(id).scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' })
        },
        changePlatform() {
            this.selectedCategory = this.categories[this.selectedPlatform.platform_id][0];
            this.topProductsDataShow = false;
            // this.selectedGlobalBrand = this.allBrands[this.selectedPlatform.platform_id][0];
            this.getAllProducts();
        },
        backToTopPerformance() {
            this.productCompare = false;
            this.comparisonList = [];
            localStorage.removeItem("compareProducts");
            this.getTopProducts();
        },
        goToProductSentiments() {
            localStorage.setItem("compareProducts", true);
            if (this.selectedView) {
                localStorage.setItem('savedView', this.selectedView.view_id);
            }
            this.$nextTick(() => {
                this.$router.push("/sentiment/product");
            });
        },
        applyFilters() {
            if (!this.productCompare) {
                this.$nextTick(() => {
                    this.getTopProducts();
                })
            } else {
                for (let itemIndex in this.comparisonList) {
                    this.getProductReviews(itemIndex);
                }
                if (this.comparisonList.length > 1) {
                    this.updateVOCData();
                };
            }
        },

        getInsightsData() {
            this.getKeywordInsightsData();
            this.getMostReviewsInsightsData();
            this.getWorstReviewsInsightsData();
        },

        setProductComparison() {
            this.comparisonList = [];
            this.getSavedViews();
            this.prepareComparisonList();
            this.productCompare = true;
        },
        updateVOCData() {
            this.getReviewCount();
            this.getVoiceOfCustomer();
        },
        updateComparisonData(index) {
            this.getProductReviews(index);
            if (this.comparisonList.length > 1) {
                this.updateVOCData();
            }
        },
        removeCompareCard(index) {
            this.comparisonList.splice(index, 1);
        },
        prepareComparisonList() {
            if (!this.comparisonList.length) {
                this.comparisonList.push({
                    selectedProduct: this.defaultComparisonProduct,
                    ratingsData: {},
                    sentiments: [],
                    currentTab: "Sentiment Overview",
                    img: "",
                })
                this.getProductReviews(0);
            } else {
                this.comparisonList.push({
                    selectedProduct: null,
                    ratingsData: {},
                    sentiments: [],
                    currentTab: "Sentiment Overview",
                    img: ""
                })
            }

            this.$nextTick(() => {
                if (this.comparisonList.length > 1 && this.comparisonList.length < 5) {
                    document.getElementById(`compare-card-${this.comparisonList.length - 1}`).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
                    const main = document.getElementsByTagName('main');
                    main.scrollTop = 0;
                    document.documentElement.scrollTop = 0;
                }
            })
        },
        getUpdatedProduct(index) {
            this.getProductReviews(index);
            if (this.comparisonList.length > 1) {
                this.updateVOCData();
            }
        },
        slideTab(id, tabName, index) {
            this.comparisonList[index].currentTab = tabName;
            document.getElementById(id).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' })
        },
        getAllProducts() {
            this.vocData = [];
            this.vocPieChart = [];
            this.vocStack = {};
            this.reviewCountChart = {};

            const url = "/api/v2/indian_clients/product_brand";
            const payload = {
                start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
                client: this.client,
                channel: this.selectedPlatform.platform_id,
                category: this.selectedCategory.key,
                label: "product",
                language: this.$store.state.DemoStore.selectedLanguage.key,
                feature_id: this.featureId,
            }

            this.loader = true;
            this.$http.post(url, payload).then(res => {
                res.body.data[this.selectedPlatform.platform_id].map(brand => {
                    brand.children.map((product, index) => {
                        product.id = `${brand.id}+${product.id}`;
                        if (brand.id === this.brandNameFromLogin && index === 0) {
                            this.defaultComparisonProduct = product.id;
                        }
                        // This check is only for demo account, can be removed later if fouund a good solution
                        else if (this.client === 'lyxel_labs') {
                            if (brand.id === 'godrej') {
                                this.defaultComparisonProduct = product.id;
                            }
                        }
                    })
                })

                this.allProducts = res.body.data;

                if (localStorage.savedView) {
                    this.getSavedViews();
                } else {
                    this.plotProducts();
                }
                this.loader = false;
            }).catch(err => {
                this.loader = false;
                console.log("Error in getting all products", err)
            })
        },
        getPlatformsAndCategories() {
            this.platforms = [];
            this.selectedPlatform = "";
            this.categories = {};
            this.selectedCategory = [];

            const url = "/api/v2/india_clients/product_platform_details";
            const payload = {
                client: this.client,
                start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
                non_sov: true,
                language: this.$store.state.DemoStore.selectedLanguage.key,
                feature_id: this.featureId,
            }

            this.loader = true;

            this.$http.post(url, payload).then(res => {
                this.loader = false;
                this.platforms = res.body.data.platform;
                this.selectedPlatform = this.platforms[0];
                this.categories = res.body.data.price;
                this.selectedCategory = this.categories[this.selectedPlatform.platform_id][0]
                this.getAllProducts();
                this.getAllBrands();

                if (localStorage.compareProducts) {
                    this.productCompare = localStorage.compareProducts;
                }

                localStorage.removeItem('compareProducts');
            }).catch(err => {
                this.loader = false
                console.log("Error in fetching platforms and categories", err)
            })
        },
        plotProducts() {
            this.$nextTick(() => {
                if (this.productCompare) {
                    this.comparisonList = [];
                    this.prepareComparisonList();
                } else {
                    this.getTopProducts();
                }
            })
        },
        switchTab(tabName) {
            this.topProductsDataShow = false;
            this.selectedTab = tabName;
            this.getTopProducts();
        },
        getKeywordInsightsData() {
            const url = "/api/v2/new/keyword";
            const productDetails = this.selectedGlobalProduct.split("+");;
            const brandName = productDetails[0];
            const productID = productDetails[1];
            this.viewKeywordInsightsData = ''
            const payload = {
                start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
                channel: this.selectedPlatform.platform_id,
                brand: [brandName],
                category: [this.selectedCategory.key],
                product: [productID],
                  language: this.$store.state.DemoStore.selectedLanguage.key,

            };

            this.$http.post(url, payload).then(res => {
                this.viewKeywordInsightsData = res.body.data;
            }).catch(err => {
                this.modalLoader = false;
                console.log(`Error in keyword insights`, err);
            });
        },

        getMostReviewsInsightsData() {
            const url = "/api/v2/most/reviews";
            const productDetails = this.selectedGlobalProduct.split("+");;
            const brandName = productDetails[0];
            const productID = productDetails[1];
            this.viewKeywordInsightsData = ''
            const payload = {
                start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
                channel: this.selectedPlatform.platform_id,
                brand: [brandName],
                category: [this.selectedCategory.key],
                product: [productID],
                  language: this.$store.state.DemoStore.selectedLanguage.key,

            };

            this.$http.post(url, payload).then(res => {
                this.viewMostReviewsInsightsData = res.body.data;
            }).catch(err => {
                this.modalLoader = false;
                console.log(`Error in  most reviews insights`, err);
            });
        },

        getWorstReviewsInsightsData() {
            const url = "/api/v2/worst/reviews";
            const productDetails = this.selectedGlobalProduct.split("+");
            const brandName = productDetails[0];
            const productID = productDetails[1];
            this.viewKeywordInsightsData = ''
            const payload = {
                start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
                channel: this.selectedPlatform.platform_id,
                brand: [brandName],
                category: [this.selectedCategory.key],
                product: [productID],
                  language: this.$store.state.DemoStore.selectedLanguage.key,

            };
            this.$http.post(url, payload).then(res => {
                this.viewWorstReviewsInsightsData = res.body.data;
            }).catch(err => {
                this.modalLoader = false;
                console.log(`Error in  worst reviews insights`, err);
            });
        },

        getTopProducts() {
            const url = "/api/v2/indian_clients/top_products";
            const payload = {
                start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
                client: this.client,
                channel: this.selectedPlatform.platform_id,
                brand: [this.selectedGlobalBrand.id],
                category: [this.selectedCategory.key],
                key_value: this.tabKeyMapper[this.selectedTab].keyVal,
                key_type: this.tabKeyMapper[this.selectedTab].keyType,
                  language: this.$store.state.DemoStore.selectedLanguage.key,
            }

            this.topProductsLoaderForTabs = true;
            this.topProducts = [];

            this.$http.post(url, payload).then(res => {
                this.topProductsLoaderForTabs = false;
                this.topProductsDataShow = res.body.data_present
                if (res.body.data) {
                    this.topProducts = res.body.data;

                    if (this.selectedTab === "Top Reviewed") {
                        this.selectedGlobalProduct = `${this.selectedGlobalBrand.id}+${res.body.data[0].product_id}`;
                        this.getCategoryWiseProducts()
                    }
                }

            }).catch(err => {
                this.topProductsLoaderForTabs = false;
                console.log(`Error in getting top products`, err)
            })
        },
        getProductReviews(index = 0) {
            const productDetails = this.comparisonList[index].selectedProduct.split("+");
            const brandName = productDetails[0];
            const productName = productDetails[1];

            this.comparisonList[index].ratingsData = {};
            this.comparisonList[index].sentiments = [];

            const url = "/api/v2/indian_clients/compare_data";
            const payload = {
                start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
                client: this.client,
                channel: this.selectedPlatform.platform_id,
                  language: this.$store.state.DemoStore.selectedLanguage.key,
                compare: [{
                    brand_name: brandName,
                    category_name: this.selectedCategory.key,
                    product_id: productName
                }],
                compare_type: "product"
            }

            this.reviewLoader = true;

            this.$http.post(url, payload).then(res => {
                this.reviewLoader = false;
                this.comparisonList[index].ratingsData = res.body.data[productName].reviews.ratings;
                this.comparisonList[index].sentiments = res.body.data[productName].sentiment;
                this.comparisonList[index].img = res.body.data[productName].product_image;
            }).catch(err => {
                this.reviewLoader = false;
                console.log(`Error in getting product review`, err);
            })
        },
        getVoiceOfCustomer() {
            let products = this.comparisonList.map(product => product.selectedProduct.split("+")[1]);
            this.numberOfReviews = [];
            this.reviewCountChart = {};
            this.vocData = [];
            this.vocPieChart = [];
            this.vocStack = {}

            const url = `/api/v2/reviews/bulk?`;

            const payload = {
                channel: this.selectedPlatform.platform_id,
                start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
                interval: "month",
                products: products,
                  language: this.$store.state.DemoStore.selectedLanguage.key,
            }
            this.vocLoader = true;

            this.$http.post(url, payload).then(res => {
                this.vocLoader = false;
                this.vocData = res.body.data;
                this.$nextTick(() => {
                    this.plotVOCCharts();
                })
            }).catch(err => {
                this.vocLoader = false;
                console.log(`Error in getting voice of customers`, err)
            })
        },
        plotVOCCharts() {
            const pieColors = ["#FCB117", "#46A493", "#899EFC"];

            let stackCategories = [];
            let positiveData = [];
            let negativeData = [];
            let neutralData = [];

            let pieChartData = [{
                name: 'Voice of Customers',
                colorByPoint: true,
                data: []
            }];

            this.vocData.map((series, index) => {
                stackCategories.push(series.product_name);

                positiveData.push(series.rating_sentiment.positive.count);
                negativeData.push(series.rating_sentiment.negative.count);
                neutralData.push(series.rating_sentiment.neutral.count);

                pieChartData[0].data.push({
                    name: series.product_name,
                    y: series.count,
                    color: pieColors[index]
                });
            });

            this.vocStack = {
                categories: stackCategories,
                seriesData: [
                    {
                        name: "Positive",
                        data: positiveData,
                        color: "#46a493",
                        borderRadius: "15px"
                    },
                    {
                        name: "Neutral",
                        data: neutralData,
                        color: "#dcdcdc",
                        borderRadius: 0
                    },
                    {
                        name: "Negative",
                        data: negativeData,
                        color: "#fc8484",
                        borderRadius: 0
                    }
                ]
            }

            this.vocPieChart = pieChartData;
        },
        changeCountInterval() {
            this.$nextTick(() => {
                this.getReviewCount();
            })
        },
        getReviewCount() {
            let products = this.comparisonList.map(product => product.selectedProduct.split("+")[1]);
            this.numberOfReviews = [];
            this.reviewCountChart = {};

            let startDate = moment(this.dateRange.startDate).format("YYYY-MM-DD");
            if (this.reviewCountInterval === 'week' || this.reviewCountInterval === 'day') {
                startDate = moment(this.dateRange.endDate).subtract(1, 'month').format("YYYY-MM-DD");
            }

            const url = `/api/v2/reviews/histogram`;

            const payload = {
                channel: this.selectedPlatform.platform_id,
                start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
                interval: this.reviewCountInterval,
                products: products,
                  language: this.$store.state.DemoStore.selectedLanguage.key,
            }

            this.countLoader = true;

            this.$http.post(url, payload).then(res => {
                this.countLoader = false;
                this.numberOfReviews = res.body.data;
                this.prepareReviewCountChartData();
            }).catch(err => {
                this.countLoader = false;
                console.log(`Error in getting review count timeline data`, err)
            })
        },
        prepareReviewCountChartData() {
            let colors = ["#FCB117", "#46A493", "#899EFC"]
            let xAxisData = [];
            let yAxisData = [];

            this.numberOfReviews.forEach((reviewSeries, index) => {
                yAxisData.push({
                    name: reviewSeries.product_name,
                    data: [],
                    color: colors[index]
                })

                reviewSeries.timeline.forEach(seriesData => {
                    if (index === 0) {
                        xAxisData.push(moment(seriesData.date).format("DD MMM"))
                    }
                    yAxisData[index].data.push(seriesData.review_count)
                })
            })

            this.reviewCountChart = {
                categories: xAxisData,
                seriesData: yAxisData
            }
        },
        getSelectedSavedView() {
            this.savedViewLoader = true;
            this.comparisonList = [];

            const targetView = this.savedViews.find(view => view.view_id === this.selectedView.view_id);

            this.dateRange = targetView.page_filter.dateRange;
            this.selectedPlatform = targetView.page_filter.selectedPlatform;
            this.selectedCategory = targetView.page_filter.selectedCategory;

            const compareBrandPayload = [];

            targetView.product_filter.map((brand, index) => {
                this.comparisonList.push({
                    selectedProduct: `${brand.selectedBrand}+${brand.selectedProduct}`,
                    ratingsData: {},
                    sentiments: [],
                    currentTab: "Sentiment Overview",
                    img: "",
                })

                compareBrandPayload.push({
                    brand_name: brand.selectedBrand,
                    category_name: this.selectedCategory.key,
                    product_id: brand.selectedProduct
                })

            })

            this.$nextTick(() => {
                const url = "/api/v2/indian_clients/compare_data";
                const payload = {
                    start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                    end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
                    client: this.client,
                    channel: this.selectedPlatform.platform_id,
                    compare: compareBrandPayload,
                    compare_type: "product",
                      language: this.$store.state.DemoStore.selectedLanguage.key,
                };

                this.reviewLoader = true;

                this.$http.post(url, payload).then(res => {
                    this.reviewLoader = false;
                    this.comparisonList.forEach((brand, index) => {

                        const productName = brand.selectedProduct.split("+")[1];

                        this.comparisonList[index].ratingsData = res.body.data[productName].reviews.ratings;
                        this.comparisonList[index].sentiments = res.body.data[productName].sentiment;
                        this.comparisonList[index].img = res.body.data[productName].product_image;
                    })

                    this.$nextTick(() => {
                        this.getVoiceOfCustomer();
                        this.getReviewCount();
                    })
                }).catch(err => {
                    this.reviewLoader = false;
                    console.log("Error in getting compare brand data", err)
                })
                this.savedViewLoader = false;
            });
        },
        resetViewModal() {
            this.viewModalName = "";
            this.newViewName = "";
            this.modalViewOptions = [];
            this.showViewModal = false;
        },
        openViewModal(viewType) {
            this.modalViewOptions = [
                ...this.viewOptions,
                {
                    view_id: 'add_new',
                    view_name: 'Add New'
                },
            ];

            if (viewType === 'Edit View') {
                this.newViewName = this.selectedView.view_name;
            } else if (viewType === 'Save View') {
                this.selectedModalView = {
                    view_id: 'add_new',
                    view_name: 'Add New'
                };

                this.newViewName = "";
            }

            this.$nextTick(() => {
                this.viewModalName = viewType;
                this.showViewModal = true;
            })
        },
        getSavedViews() {
            this.savedViews = [];
            this.viewOptions = [];
            const url = "/api/v2/reviews/comparison_view?view_for=product_reviews_compare";

            this.$http.get(url).then(res => {
                this.savedViews = res.data.data;
                if (this.savedViews.length) {
                    this.savedViews.map(view => {
                        this.viewOptions.push({
                            view_id: view.view_id,
                            view_name: view.view_name
                        })
                    })
                }

                if (localStorage.savedView) {
                    this.selectedView = this.viewOptions.find(view => view.view_id === localStorage.savedView);
                    localStorage.removeItem("savedView");
                    this.$nextTick(() => {
                        this.getSelectedSavedView();
                    });
                }

                if (
                    this.viewModalName === 'Edit View' ||
                    (
                        this.viewModalName === 'Save View' &&
                        this.selectedModalView.view_id === 'add_new'
                    )
                ) {
                    this.selectedView = this.viewOptions.find(view => view.view_name === this.newViewName);
                    this.resetViewModal();
                } else this.resetViewModal();
            }).catch(err => {
                console.log(`Error getting saved views:: ${err}`);
            })
        },
        saveCompareView() {
            if (this.viewModalName === "Edit View" && !this.newViewName) {
                this.$bvToast.toast('Please provide a name to edit this view', {
                    title: 'Edit View',
                    variant: 'danger',
                    solid: true,
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 2000,
                    appendToast: true,
                });
                return;
            } else if (this.selectedModalView.view_id === "add_new" && !this.newViewName) {
                this.$bvToast.toast('Please provide a name to save new view', {
                    title: 'Save View',
                    variant: 'danger',
                    solid: true,
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 2000,
                    appendToast: true,
                });
                return;
            }

            this.spinLoader = true;

            if (this.newViewName) {
                let capitalizedText;
                capitalizedText = this.newViewName.split(' ').map(word =>
                    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                ).join(' ');

                this.newViewName = capitalizedText;
            }

            const url = "/api/v2/reviews/comparison_view";
            let payload = {
                view_for: "product_reviews_compare",
                view_data: {
                    page_filter: {
                        dateRange: {
                            startDate: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                            endDate: moment(this.dateRange.endDate).format("YYYY-MM-DD")
                        },
                        selectedPlatform: this.selectedPlatform,
                        selectedCategory: this.selectedCategory
                    },
                    product_filter: this.comparisonList.map(compareProduct => {
                        return {
                            selectedBrand: compareProduct.selectedProduct.split("+")[0],
                            selectedProduct: compareProduct.selectedProduct.split("+")[1]
                        }
                    }),
                    view_name: this.newViewName
                },
            };

            if (this.viewModalName === 'Edit View') {
                payload = {
                    ...payload,
                    view_id: this.selectedView.view_id
                }
            }

            if (this.viewModalName === 'Save View' && this.selectedModalView.view_id !== 'add_new') {
                payload.view_data.view_name = this.selectedModalView.view_name,
                    payload = {
                        ...payload,
                        view_id: this.selectedModalView.view_id
                    }
            }

            this.$http.post(url, payload).then(res => {
                this.getSavedViews();
                this.spinLoader = false;
            }).catch(err => {
                console.log("Error in saving view", err);
                // console.log("check errr",err.data);   
                 this.$bvToast.toast(err.data.msg, {
                    title: "Save Error",
                    variant: "danger",
                    solid: true,
                    toaster: "b-toaster-center",
                    autoHideDelay: 3000,
                    appendToast: true,
                });
                console.log(`Error in saving view::${err}`);
                this.spinLoader = false;
            });
        },
        resetComparisonList() {
            if (this.productCompare) {
                this.comparisonList = [];
                this.$nextTick(() => {
                    this.prepareComparisonList();
                })
            }
        },
        resetSavedView() {
            this.selectedView = "";
            this.resetComparisonList();
        },
        deleteView() {
            const url = "/api/v2/reviews/comparison_view";
            let payload = {
                view_id: [this.selectedView.view_id],
                view_for: "product_reviews_compare"
            }

            this.spinLoader = true;
            this.$http.delete(url, { body: payload }).then((res) => {

                this.getSavedViews();
                this.resetSavedView();

                this.$bvToast.toast('View deleted successfully', {
                    title: 'Delete View',
                    variant: 'success',
                    solid: true,
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 2000,
                    appendToast: true,
                });

                this.spinLoader = false;

            }).catch((err) => {
                console.log(err);
                this.$bvToast.toast('Error in deleting this view', {
                    title: 'Delete View',
                    variant: 'danger',
                    solid: true,
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 2000,
                    appendToast: true,
                });
                this.spinLoader = false;
            })

            this.showDeleteModal = false;
        },
        downloadReviews() {
            this.reviewLoader = true;
            const url = "/api/v2/reviews/brand";
            const payload = {
                start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
                client: this.client,
                channel: this.selectedPlatform.platform_id,
                category: [this.selectedCategory.value],
                  language: this.$store.state.DemoStore.selectedLanguage.key,
            }

            this.$http.post(url, payload).then(res => {
                this.reviewLoader = false;
                window.location = res.body.data.file_url;
            }).catch(err => {
                this.$bvToast.toast('Error in downloading reviews', {
                    title: 'Download Reviews',
                    variant: 'danger',
                    solid: true,
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 2000,
                    appendToast: true,
                });
                console.log("Error in downloading report", err)
            })
        },
        filterCustomDate(filter) {
            switch (filter) {
                case 'Overview':
                    this.selectedFilterState = filter;
                    this.dateRange = {
                        startDate: moment().startOf('year').format("YYYY-MM-DD"),
                        endDate: moment().format("YYYY-MM-DD")
                    }
                    this.getSelectedProduct();
                    break;
                case 'Last Week':
                    this.selectedFilterState = filter;
                    this.dateRange = {
                        startDate: moment().subtract(1, 'week').startOf('week').format("YYYY-MM-DD"),
                        endDate: moment().subtract(1, 'week').endOf('week').format("YYYY-MM-DD")
                    }
                    this.getSelectedProduct();
                    break;
                case 'Last Month':
                    this.selectedFilterState = filter;
                    this.dateRange = {
                        startDate: moment().subtract(1, 'month').startOf('month').format("YYYY-MM-DD"),
                        endDate: moment().subtract(1, 'month').endOf('month').format("YYYY-MM-DD")
                    }
                    this.getSelectedProduct();
                    break;
                case 'Last Year':
                    this.selectedFilterState = filter;
                    this.dateRange = {
                        startDate: moment().subtract(1, 'year').startOf('year').format("YYYY-MM-DD"),
                        endDate: moment().subtract(1, 'year').endOf('year').format("YYYY-MM-DD")
                    }
                    this.getSelectedProduct();
                    break;
                default:
                    break;
            }
        },
        getAllBrands() {
            const url = "/api/v2/indian_clients/product_brand";
            const payload = {
                start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
                client: this.client,
                label: "brand",
                language: this.$store.state.DemoStore.selectedLanguage.key,
                feature_id: this.featureId,
            }

            this.allBrands = null;
            this.reviewsLoader = true;
            this.$http.post(url, payload).then(res => {
                this.allBrands = res.body.data;
                this.reviewsLoader = false;

                this.selectedGlobalBrand = this.allBrands[this.selectedPlatform.platform_id].find(brand => {
                    if (this.client === "lyxel_labs") {
                        return brand.id === 'godrej';
                    }
                    return brand.id === this.brandNameFromLogin;
                })

                this.$nextTick(() => {
                    this.getTopProducts()
                })
            }).catch(err => {
                console.log("Error in getting all brands", err)
                this.reviewsLoader = false;
            })
        },
        getCategoryWiseProducts() {
            const url = "/api/v2/indian_clients/product_brand";
            const payload = {
                start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
                client: this.client,
                channel: this.selectedPlatform.platform_id,
                category: this.selectedCategory.key,
                label: "product",
                  language: this.$store.state.DemoStore.selectedLanguage.key,
                feature_id: this.featureId,
            }

            this.loader = true;
            this.$http.post(url, payload).then(res => {
                res.body.data[this.selectedPlatform.platform_id].map(brand => {
                    brand.children.map((product, index) => {
                        product.id = `${brand.id}+${product.id}`;
                    })
                })

                this.categoryWiseProducts = res.body.data;

                this.$nextTick(() => {
                    this.getSelectedProduct();
                    this.loader = false;
                })
            }).catch(err => {
                this.loader = false;
                console.log("Error in getting all products", err)
            })
        },
        getSelectedProduct() {
            if (!this.selectedPlatform) {
                this.$bvToast.toast('Please select a platform', {
                    title: 'Edit View',
                    variant: 'danger',
                    solid: true,
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 2000,
                    appendToast: true,
                });
                return;
            }

            if (!this.selectedCategory.key) {
                this.$bvToast.toast('Please select a category', {
                    title: 'Edit View',
                    variant: 'danger',
                    solid: true,
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 2000,
                    appendToast: true,
                });
                return;
            }


            if (!this.selectedGlobalProduct) {
                this.$bvToast.toast('Please select a product', {
                    title: 'Edit View',
                    variant: 'danger',
                    solid: true,
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 2000,
                    appendToast: true,
                });
                return;
            }

            this.getInsightsData();
            this.getPerformanceRating();

            this.globalProductReviews = {};
            this.globalProductSentiments = {};
            this.globalProductAISummary = "";
            this.globalProductName = "";
            this.globalProductMarketShare = {};

            const productDetails = this.selectedGlobalProduct.split("+");
            const brandName = productDetails[0];
            const productID = productDetails[1];

            const url = "/api/v2/indian_clients/compare_data";
            const payload = {
                start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
                client: this.client,
                channel: this.selectedPlatform.platform_id,
                compare: [{
                    brand_name: brandName,
                    category_name: this.selectedCategory.key,
                    product_id: productID
                }],
                compare_type: "product",
                // positive_limit: Number(this.selectedPositiveCloudLimit),
                // negative_limit: Number(this.selectedNegativeCloudLimit)
                positive_limit: 50,
                negative_limit: 50,
                  language: this.$store.state.DemoStore.selectedLanguage.key,
            }

            this.reviewLoader = true;

            this.$http.post(url, payload).then(res => {

                const productData = res.body.data[this.selectedGlobalProduct.split("+")[1]];

                this.globalProductReviews = productData.reviews;
                this.globalProductSentiments = productData.sentiment;
                this.globalProductAISummary = productData.summary;
                this.globalProductName = productData.product_name;
                this.globalProductImage = productData.product_image;
                this.globalProductMarketShare = productData.market_share;

                this.reviewLoader = false;

                this.$nextTick(() => {
                    this.processTable("#product-sentiments-table")
                })
            }).catch(err => {
                this.reviewLoader = false;
                console.log(`Error in getting product review`, err);
            })
        },
        updateSelectedLabels(value) {
            return value.platform_name.replaceAll('_', ' ')
        },
        getPerformanceRating() {
            const productDetails = this.selectedGlobalProduct.split("+");
            const brandName = productDetails[0];
            const productID = productDetails[1];

            const url = "/api/v2/reviews/starcount";
            const payload = {
                start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
                channel: this.selectedPlatform.platform_id,
                brand: [brandName],
                category: [this.selectedCategory.key],
                product: [productID],
                interval: "month",
                language: this.$store.state.DemoStore.selectedLanguage.key,
            };

            this.performanceRatingsData = [];
            this.reviewLoader = true;

            this.$http.post(url, payload).then(res => {
                this.performanceRatingsData = res.body.data;
                this.reviewLoader = false;
            }).catch(err => {
                console.error(`Error in getting performance data::${err}`);
                this.reviewLoader = false;
            });
        },
        processTable(id) {
            $(id).DataTable().destroy();

            $(id).DataTable({
                initComplete: function (settings, json) {
                    $('.dataTables_scrollBody tfoot tr').css({ visibility: 'collapse' });
                    $('.dataTables_scrollBody thead tr').css({ visibility: 'collapse' });
                    $(id).wrap("<div class='thin-scroller' style='overflow:auto; width:100%;position:relative;'></div>");
                },
                columnDefs: [
                    { "orderData": 3, "targets": 1 },
                    { "visible": false, "targets": 3 },
                    { orderable: false, targets: 2 }
                ],
                language: {
                    search: "",
                    paginate: {
                        first: "",
                        previous: "<",
                        next: ">",
                        last: "",
                    },
                    lengthMenu: "<h5>Show entries</h5> _MENU_",
                    searchPlaceholder: "Search..."
                },

                pagingType: "full_numbers",
                searching: true,
                sorting: [[1, 'desc']],
                autoWidth: false,

            })

            let search = require("../../../public/Icons_SVG/Search.svg");
            $(id + "_filter > label").append(`<div><img src='${search}' /></div>`);

        },
        openNegativeModal(keyword) {
            this.openModal(keyword, 'negative');
        },
        openPositiveModal(keyword) {
            this.openModal(keyword, 'positive');
        },
        openModal(targetKeyword, sentType = "") {
            this.selectedModalKeyword = targetKeyword;
            this.modalTitle = `${this.translatedLang['Keyword'][this.selectedLanguage.key]} : ${targetKeyword.value}`;
            this.getKeywordReviews(sentType);
            this.getKeywordSentiment();
            this.keywordModal = true;
        },
        getKeywordReviews(sentimentType) {
            const productDetails = this.selectedGlobalProduct.split("+");
            const brandName = productDetails[0];
            const productName = productDetails[1];

            const url = "/api/v2/indian_clients/keyword_reviews_data";
            const payload = {
                start_date: moment(this.modalDateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.modalDateRange.endDate).format("YYYY-MM-DD"),
                keyword: this.selectedModalKeyword.key,
                client: this.client,
                channel: this.selectedPlatform.platform_id,
                brand_name: [brandName],
                  language: this.$store.state.DemoStore.selectedLanguage.key,
                category_name: [this.selectedCategory.key],
                product_name: [productName],
                limit: 50,
                offset: 0,
                sentiment_type: sentimentType || 'positive',
                  language: this.$store.state.DemoStore.selectedLanguage.key,
            };

            this.keywordWiseReviews = [];
            this.keywordTreeData = {};
            this.modalLoader = true;

            this.$http.post(url, payload).then(res => {
                this.modalLoader = false;
                this.keywordWiseReviews = res.body.data;
                this.keywordTreeData = res.body.percent;
            }).catch(err => {
                this.modalLoader = false;
                console.log(`Error in fetching keyword reviews`, err);
            });
        },
        getKeywordSentiment() {
            const productDetails = this.selectedGlobalProduct.split("+");
            const brandName = productDetails[0];
            const productName = productDetails[1];

            const url = "/api/v2/indian_clients/keyword_sentiments_data";
            const payload = {
                start_date: moment(this.modalDateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.modalDateRange.endDate).format("YYYY-MM-DD"),
                keyword: this.selectedModalKeyword.key,
                interval: this.keywordInterval,
                client: this.client,
                  language: this.$store.state.DemoStore.selectedLanguage.key,
                channel: this.selectedPlatform.platform_id,
                brand_name: [brandName],
                category_name: [this.selectedCategory.key],
                product_name: [productName],
            };

            this.keywordWiseSentiments = {};
            this.modalLoader = true;

            this.$http.post(url, payload).then(res => {
                this.modalLoader = false;
                this.keywordWiseSentiments = res.body.data;
            }).catch(err => {
                this.modalLoader = false;
                console.log(`Error in fetching keyword sentiments`, err)
            })
        },
        resetModal() {
            this.selectedModalKeyword = "";
            this.modalTitle = "";
            this.keywordWiseReviews = [];
            this.keywordWiseSentiments = {};
            this.keywordTreeData = {};
            this.selectedModalTab = "Reviews";
            this.keywordInterval = 'month'
        },
        updateModal() {
            this.getKeywordReviews();
            this.getKeywordSentiment();
        },
        filterReviews(sentimentType) {
            this.getKeywordReviews(sentimentType)
        },
        updateSentimentData() {
            this.$nextTick(() => {
                this.getKeywordSentiment();
            })
        },
        formatNumber(number) {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
    }
}
</script>
<style scoped>
.rating-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 5%;
}

.ratings-group {
    display: grid;
    width: 90%;
    height: 15px;
    border: 1px solid #D9D9D9;
    border-radius: 10px;

    &>* {
        grid-column: 1;
        grid-row: 1;
    }
}

.inactive-ratings-bar {
    width: 100%;
    background-color: #F4F4F4;
    border: none;
    border-radius: 10px;
}

.active-ratings-bar {
    border-radius: 10px;
}

.breakdown-star {
    display: flex;
    width: 24px;
    margin-right: 0px;
    color: #FCB117;
    fill: #FCB117;
}

.star-tooltip {
    position: relative;
    cursor: pointer;
}


.star-tooltiptext {
    visibility: hidden;
    width: 330px;
    padding: 2px 4px;
    background-color: #ffffff;
    color: #000;
    border-radius: 6px;
    text-align: center;
    position: absolute;
    z-index: 7777 !important;
    bottom: 125%;
    left: 50%;
    margin-left: -60px;
    opacity: 0;
    font-size: 12px;
    transition: opacity 0.3s;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.star-tooltip:hover .star-tooltiptext {
    visibility: visible;
    opacity: 1;
}

.insight-container {
    padding: 6px 12px;
    margin-block: 12px;
    border: 1px solid #d9d9d9;
    border-radius: 5px;
}

.keyword {
    color: #0463BA !important;
    font-family: Poppins !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    line-height: 25px !important;
}

.modal-control-panel {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #D4D4D4;

    &>ul {
        list-style: none;
        display: flex;
        align-items: center;
        gap: 20px;
        margin: 0;
        padding: 0;

        &>li {
            padding-bottom: 16px;
            margin: 0;
            font-size: 16px;
            cursor: pointer;
        }

        &>li.selected-tab {
            border-bottom: 1px solid #065559;
            margin-bottom: -1px;
            color: #065559;
            font-weight: 500;
        }
    }
}

.horizontal-divider {
    border-bottom: 1px solid #D9D9D9;
}

.vertical-divider {
    border-right: 1px solid #D9D9D9;
}

.customInput {
    border-radius: 5px !important;
    height: 35px !important;
    border: 1px solid #e4e7ea;
    width: 220px;
    outline: none;
    font-family: 'poppins';
    width: 100%
}

.customInput:focus {
    border: 1px solid var(--primary_brand) !important;
    box-shadow: none !important;
}

.delete-viewBtn:hover {
    background-color: #f58181 !important;
}

.delete-alert {
    background-color: #ffecec !important;
    color: var(--red);
    font-size: 30px;
    width: 45px;
    height: 45px;
}

.graphHeading {
    font-weight: 600 !important;
    font-size: 16px !important;
    color: var(--primary_brand) !important;
    letter-spacing: 0.6px !important;
    font-family: "poppins";
    text-transform: capitalize;
}

.grayedHeading {
    font-weight: 600 !important;
    font-size: 16px !important;
    color: var(--base_color-60) !important;
    letter-spacing: 0.6px !important;
    font-family: "poppins";
    text-transform: capitalize;
}

.newComparisonIcon svg {
    height: 17px;
    transform: rotate(45deg);
    color: white;
    fill: #fff;
    margin-right: 5px;
}

.close-card {
    position: absolute;
    right: 20px;
    top: 5px;
    background-color: #dedede;
    padding: 6px 10px;
    border-radius: 50%;
    cursor: pointer;
}

.close-card:hover {
    background-color: #f0f0f0;
}

.card-heading {
    padding-bottom: 10px;
    border-bottom: 1px solid #D4D4D4;

    &>p {
        font-size: 16px;
        font-weight: 600;
        line-height: 21.76px;
        color: #065559;
    }
}

.add-comparison {
    border: 1px solid #d9d9d9;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    height: 200px;
    border-radius: 10px;
    color: #5E5E5E;
}

.plus-icon {
    font-size: 30px;
    color: #5E5E5E;
    border: 2px dashed #5E5E5E;
    border-radius: 50%;
    padding-inline: 12px;
    cursor: pointer;
}

.customselect {
    height: 37px !important;
    border-radius: 5px !important;
    background: white;
    border: 1px solid #B7B7B7 !important;
    padding-left: 11px;
    padding-right: 11px;
    margin-right: 5px;
    color: var(--primary_brand);
    width: 90%;
    text-overflow: ellipsis;
}

.customselect:focus {
    outline: none !important;
    border: 1px solid var(--primary_brand) !important;
}

.compare-card {
    background-color: white;
    border-radius: 10px;
    border: 1px solid #D9D9D9;
}

.multiline-ellipsis {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
    text-overflow: ellipsis;
}

.container {
    display: grid;
    align-items: center;
    justify-content: start;
    margin: 0;
    padding: 0;

    &>* {
        grid-column: 1;
        grid-row: 1;
    }
}

.star {
    display: flex;
    width: 16px;
    margin-right: 0px;
    color: #FCB117;
    fill: #FCB117;
}

.overlay {
    justify-self: end;
    background-color: white;
    height: 16px;
}

ul.tabs {
    display: flex;
    justify-content: flex-start;
    gap: 8px;
    margin: 0;
    padding: 0;
    border-bottom: 1px solid#D5D5D5;

    &>li {
        list-style: none;
        padding-inline: 8px;
        padding-bottom: 14px;
        cursor: pointer;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
    }

    &>li.active {
        color: #065559;
        border-bottom: 1px solid var(--primary_brand);
    }
}

.slide {
    display: flex;
    max-width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &>* {
        min-width: 100%;
    }
}

.slide::-webkit-scrollbar {
    display: none;
}

.tab {
    width: 30px;
    height: 7px;
    border-radius: 10px;
    background-color: #0655594D;
    cursor: pointer;
}

.active-tab {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: #00555A;
    cursor: pointer;
}

.slider-tab {
    width: 30px;
    height: 7px;
    border-radius: 10px;
    background-color: #0655594D;
    cursor: pointer;
}

.slider-active {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: #00555A;
    cursor: pointer;
}

.card {
    border-radius: 0.7rem !important;
    border: none !important;
    margin-bottom: 1rem;
}

button.primarycolor {
    background: var(--primary_brand);
    font-family: "Poppins", sans-serif;
    color: white;
    padding: 7px 25px;
    border-radius: 6px;
    letter-spacing: 0.2px;
    font-weight: bold;
    font-size: 14px;
}

button.navigation-btn {
    background: var(--accent_color);
    font-family: "Poppins", sans-serif;
    color: white;
    padding: 7px 25px;
    border-radius: 6px;
    letter-spacing: 0.2px;
    font-weight: bold;
    font-size: 14px;
}

button.primarycolor:hover {
    color: white;
    background: var(--primary_brand-80);
    /* border: 1.6px solid var(--base_color); */
}

button.navigation-btn:hover {
    background: var(--accent_color-80);
}

.label {
    font-size: 14px;
    font-weight: 500;
    color: #1E1E1E
}

.gap {
    gap: 14px !important;
}

.customSelect :focus {
    background: var(--base_color-5) !important;
    color: var(--primary_brand-60) !important;
    border: 1px solid var(--primary_brand-60) !important;
    outline: none !important;
    box-shadow: none !important;
    font-weight: 600;
}

.form-control {
    border-radius: 5px !important;
    padding: 6px !important;
    font-size: 12px !important;
    height: 35px !important;
    border: 1px solid var(--base_color-40) !important;
}

.section-button {
    padding: 8px 16px;
    border-radius: 8px;
    border: 1px solid #065559;
    background-color: transparent;
    font-size: 14px;
    font-weight: 400;
    line-height: 19.04px;
    color: #00555A;
}

.active-button {
    background-color: #065559;
    color: white;
}

.product-section-card {
    border-radius: 10px;
    border: 1px solid #D9D9D9;
    background-color: transparent;
    height: 100%;
}

.logo-container {
    border-radius: 10px;
    border: 0px solid #D9D9D9;
    background: linear-gradient(360deg, rgba(0, 0, 0, 0.05) 0%, rgba(255, 255, 255, 0) 100%);
    box-shadow: 0px 1px 6px 0px #0000002E;
    max-height: 220px;
    max-width: 100%;
}

a {
    color: #0463BA;
    font-family: Poppins;
    font-size: 14px;
    font-weight: 500;
    line-height: 25px;
    text-transform: capitalize;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.tree-leaf {
    height: 25px;
    margin: auto;
    line-height: 25px;
    cursor: pointer;
}

/* datatable */
.dataTables_filter div {
    height: 35px;
    width: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    margin-left: -15px;
    background-color: var(--primary_brand);
}

.dataTables_filter img {
    height: 17px;
    filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg) brightness(103%) contrast(104%);
}

table.dataTable th {
    background-color: #e7eeef !important;
    padding: 16px 32px !important;
    font-family: "Poppins", sans-serif !important;
    font-size: 14px !important;
    font-weight: 600 !important;
}

table.dataTable>thead>tr:first-child>th:first-child {
    border-top-left-radius: 5px !important;
}

table.dataTable>thead>tr:first-child>th:last-child {
    border-top-right-radius: 5px !important;
}

table.dataTable>tbody>tr>td {
    font-family: "Poppins", sans-serif !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    color: black !important;
}

thead {
    background: none !important;
}

.dataTables_info {
    position: relative;
    top: 9px;
    left: 0;
    z-index: 100;
    float: none;
    width: auto;
    font-size: 15px;
    color: var(--primary_brand-80);
}

.dataTables_paginate {
    position: relative;
    top: 6px;
    z-index: 100;
    float: right;
    width: 50vw;
}

.customMultiselect .multiselect__placeholder {
    margin-bottom: 6px !important;
    padding: 0px !important;
    color: var(--primary_brand-40) !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__tags {
    border: 1px solid var(--base_color-40) !important;
    padding-top: 6px !important;
    min-height: 35px !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__select {
    min-height: 35px !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__select::before {
    top: 56% !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__tag {
    background: var(--primary_brand-80) !important;
    margin-bottom: 0px !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__tag-icon:after {
    color: #fff !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__content-wrapper {
    border: 1px solid var(--base_color-40) !important;
    border-top: none !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__option--selected.multiselect__option--highlight {
    background: var(--red) !important;
    color: var(--white) !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__option--highlight {
    background: var(--base_color-20) !important;
    color: var(--primary_brand-80) !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__element {
    color: var(--primary_brand-80) !important;
    border-bottom: 1px solid var(--base_color-20);
    font-family: "poppins";
}

/* width */
.customMultiselect ::-webkit-scrollbar {
    width: 10px;
    border-radius: 10px;
}

/* Track */
.customMultiselect ::-webkit-scrollbar-track {
    background: var(--base_color-20);
    border-radius: 10px;
}

/* Handle */
.customMultiselect ::-webkit-scrollbar-thumb {
    background: var(--base_color-80);
    border-radius: 10px;
}

/* Handle on hover */
.customMultiselect ::-webkit-scrollbar-thumb:hover {
    background: var(--base_color);
}

.thin-scrollerBar::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
    border-radius: 6px;
    background: #EBEDEE;
}

.thin-scrollerBar::-webkit-scrollbar {
    height: 6px;
    width: 6px;
}

.thin-scrollerBar::-webkit-scrollbar-thumb {
    border-radius: 6px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background: #B3B2B9;
}

.thin-scrollerBar::-webkit-scrollbar-thumb:hover {
    background: #8B8D94;
    cursor: pointer;
}

.inSightsContainer {
    border-radius: 5px !important;
    border: 1px solid #D9D9D9;
}

.inSightsContainer>div:first-child {
    border-right: 1px solid #D9D9D9;
}

.insightsContent {
    font-weight: 400;
    font-size: 14px;
    color: #1E1E1E;
}
</style>
